module.exports = __webpack_public_path__ + "img/new-website-logo-dark.da435d17.png";